import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Container, Points, Img, GiftName, GiftValue, Button} from './styles';

const Gift = ({title, points, image, subTitle, giftId, pointsOnLink, affordable, history}) => {
  const handleClick = event => {
    if (!affordable) return;

    event.preventDefault();
    history.push(`/gifts/order/${giftId}/summary`);
  };

  return (
    <Container>
      <Img src={image} />
      <Points>
        {points} <span>pts</span>
      </Points>
      <GiftName>{title.replace(/&#8217;/g, '’').replace(/&rsquo;/gi, '’')}</GiftName>
      <GiftValue>
        {subTitle}
        {subTitle && (
          <>
            {' '}
            <sup>TTC</sup>
          </>
        )}
      </GiftValue>
      <Button
        href={affordable ? `/gifts/order/${giftId}/summary` : undefined}
        onClick={handleClick}
        role={!affordable ? 'button' : undefined}>
        {affordable ? 'Choisir ce cadeau' : `Il vous manque ${pointsOnLink} pts`}
      </Button>
    </Container>
  );
};

Gift.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  points: PropTypes.string,
  image: PropTypes.string,
  giftId: PropTypes.number,
  pointsOnLink: PropTypes.number,
  affordable: PropTypes.bool,
  history: PropTypes.object,
};

export default Gift |> withRouter;
